import React from 'react'
import Field from '../Field'

import e from '../../Utils/Event'

export default function Form(props) {
  let { fields, dict, sInput, containRef, showIDCard, setShowIDCard, authTypeHidden, setShowAuthFailDialog, setAuthTip, setAuthBtn, openFaceAuth } = props

  function openSelector(props) {
    e.emit('selector', props)
  }

  return (<div className="Form">
    {fields.map((ele, index) => (<Field {...props} key={index} sInput={sInput} containRef={containRef} showIDCard={showIDCard} setShowIDCard={setShowIDCard} authTypeHidden={authTypeHidden} setShowAuthFailDialog={setShowAuthFailDialog} setAuthTip={setAuthTip} setAuthBtn={setAuthBtn} openFaceAuth={openFaceAuth} {...ele} openSelector={openSelector} options={ele.options || dict[ele.dictName]} />))}
  </div>)
}